import classNames from "classnames";
import Widget, { WidgetProps } from "@/components/Widget/Widget";
import { twMerge } from "tailwind-merge";

interface SimulatorProps extends React.HTMLAttributes<HTMLDivElement> {
  widgetProps?: WidgetProps;
}

const Simulator = ({ className, widgetProps, ...props }: SimulatorProps) => {
  return (
    <div
      className={twMerge(
        classNames(
          "flex items-center justify-center",
          {
            "bg-vpGray-900": widgetProps?.backgroundType === "fordark",
          },
          className
        )
      )}
      {...props}
    >
      <Widget {...widgetProps} />
    </div>
  );
};

export default Simulator;
